import { useRef } from "react";
import {
  motion,
  useReducedMotion,
  useScroll,
  useSpring,
  useTransform,
} from "framer-motion";
import { Link } from "react-router-dom";
import glv from "../utils/getLocalizedValue";
import "../style/liquidiq-insertions.css";

const publicUrl = process.env.PUBLIC_URL || "";

function HomeLiquidIQSection({ scrollContainerRef }) {
  const reduceMotion = useReducedMotion();
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    container: scrollContainerRef,
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 90,
    damping: 26,
    mass: 0.45,
  });
  const imageY = useTransform(smoothProgress, [0, 1], ["3%", "-3%"]);
  const imageScale = useTransform(
    smoothProgress,
    [0, 0.5, 1],
    [1.035, 1, 1.025]
  );
  const reveal = reduceMotion
    ? { initial: false }
    : {
        initial: { opacity: 0, y: 24 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, amount: 0.34 },
        transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
      };

  return (
    <div className="liquidiq-home" ref={sectionRef}>
      <motion.div
        className="liquidiq-home__media"
        initial={reduceMotion ? false : { opacity: 0, scale: 1.025, x: 24 }}
        whileInView={reduceMotion ? undefined : { opacity: 1, scale: 1, x: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <motion.img
          className="liquidiq-home__image"
          src={`${publicUrl}/images/liquidiq/white-back-hq.png`}
          style={reduceMotion ? undefined : { y: imageY, scale: imageScale }}
          decoding="async"
          alt={glv(
            "LiquidIQ liquid cooling workstation",
            "LiquidIQ 수냉 워크스테이션"
          )}
        />
      </motion.div>
      <div className="liquidiq-home__veil" aria-hidden="true" />

      <div className="liquidiq-home__inner">
        <motion.div className="liquidiq-home__copy" {...reveal}>
          <p className="liquidiq-insertion-eyebrow">CES 2027</p>
          <h2 id="home-liquidiq-title" className="liquidiq-home__title">
            {glv("A first look at LiquidIQ.", "LiquidIQ를 가장 먼저 만나보세요.")}
          </h2>
          <p className="liquidiq-home__description">
            {glv(
              "Meet our new liquid cooling workstation, where IMMC2 cooling and live thermal control work together in one compact system.",
              "IMMC2 냉각 기술과 실시간 열 제어가 하나의 컴팩트한 시스템으로 작동하는 새로운 수냉 워크스테이션을 CES에서 만나보세요."
            )}
          </p>
          <p className="liquidiq-home__date">
            {glv("Releasing February 28th 2027", "2027년 2월 28일 출시 예정")}
          </p>
          <Link
            className="liquidiq-primary-link"
            to="/product/liquidiq"
            aria-describedby="home-liquidiq-title"
          >
            <span>{glv("Explore LiquidIQ", "LiquidIQ 살펴보기")}</span>
            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path
                d="M4 10h11m-4-4 4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </motion.div>
      </div>
    </div>
  );
}

export default HomeLiquidIQSection;
